export class ComplianceDialogReasonsModel {

 decision: string | any;
 reason: string;
}
